import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoGraphicItems from 'eco-design/sections/eco-graphic-items';
export default function Comp() {
    const { t } = useLang('theProduct.ListA2');
    const itemsA = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1736321301754/bg1.jpg',
            title: t('item1_title'),
            desc: t('item1_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1736321301754/bg1.jpg',
            title: t('item2_title'),
            desc: t('item2_desc'),
        },
    ];
    return (
        <>
            <EcoSpace />
            <EcoGraphicItems items={itemsA} />
        </>
    );
}
